import { render, staticRenderFns } from "./Interactions.pug?vue&type=template&id=64fe0e92&lang=pug&"
import script from "./Interactions.vue?vue&type=script&lang=js&"
export * from "./Interactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports